module.exports = {
  "course": {
    "introduce": "介绍",
    "catalogue": "目录",
    "courseCatalogue": "课程目录",
    "courseProfile": "课程介绍",
    "courseDetail": "课程详情",
    "label": "标签",
    "chapter": "章节",
    "chapterProfile": "章节介绍",
    "playing": "正在播放",
    "chapterLength": "{0}章课程"
  },
}



// WEBPACK FOOTER //
// ./src/i18n/course/zh-CN.js